import ImgCarousel from './ImgCarousel';

export default ImgCarousel;
